module.exports = __webpack_public_path__ + "static/img/200221.0b83e280.png";